"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = _3DMaterials;

var _DMaterials = require("@adobe/react-spectrum-workflow/dist/3DMaterials");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function _3DMaterials(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_DMaterials.A4u3DMaterials, null));
}